// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see EarningsTrackerFetchAttemptEvent
 */
export var EarningsTrackerFetchAttempt = function (_a) {
    var timeframe = _a.timeframe, timeframeMonth = _a.timeframeMonth, timeframeYear = _a.timeframeYear;
    return ({
        name: "EarningsTracker Fetch Attempt",
        parameters: {
            cdf_entity: "EarningsTracker",
            cdf_action: "Fetch",
            timeframe: timeframe !== undefined && timeframe !== null ? timeframe.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_month: timeframeMonth !== undefined && timeframeMonth !== null ? timeframeMonth.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_year: timeframeYear !== undefined && timeframeYear !== null ? timeframeYear.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see EarningsTrackerFetchSuccessEvent
 */
export var EarningsTrackerFetchSuccess = function (_a) {
    var timeframe = _a.timeframe, timeframeMonth = _a.timeframeMonth, timeframeYear = _a.timeframeYear, fetchDuration = _a.fetchDuration;
    return ({
        name: "EarningsTracker Fetch Success",
        parameters: {
            cdf_entity: "EarningsTracker",
            cdf_action: "Fetch",
            timeframe: timeframe !== undefined && timeframe !== null ? timeframe.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_month: timeframeMonth !== undefined && timeframeMonth !== null ? timeframeMonth.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_year: timeframeYear !== undefined && timeframeYear !== null ? timeframeYear.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            fetch_duration: fetchDuration !== undefined && fetchDuration !== null ? fetchDuration.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see EarningsTrackerFetchErrorEvent
 */
export var EarningsTrackerFetchError = function (_a) {
    var timeframe = _a.timeframe, timeframeMonth = _a.timeframeMonth, timeframeYear = _a.timeframeYear, fetchDuration = _a.fetchDuration, errorMessage = _a.errorMessage, errorCode = _a.errorCode, fetchCancelled = _a.fetchCancelled;
    return ({
        name: "EarningsTracker Fetch Error",
        parameters: {
            cdf_entity: "EarningsTracker",
            cdf_action: "Fetch",
            timeframe: timeframe !== undefined && timeframe !== null ? timeframe.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_month: timeframeMonth !== undefined && timeframeMonth !== null ? timeframeMonth.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_year: timeframeYear !== undefined && timeframeYear !== null ? timeframeYear.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            fetch_duration: fetchDuration !== undefined && fetchDuration !== null ? fetchDuration.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_message: errorMessage !== undefined && errorMessage !== null ? errorMessage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_code: errorCode !== undefined && errorCode !== null ? errorCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            fetch_cancelled: fetchCancelled !== undefined && fetchCancelled !== null ? fetchCancelled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see EarningsTrackerOpenLaunchAppletEvent
 */
export var EarningsTrackerOpenLaunchApplet = function (_a) {
    var entrypoint = _a.entrypoint;
    return ({
        name: "EarningsTracker Open LaunchApplet",
        parameters: {
            cdf_entity: "EarningsTracker",
            cdf_action: "Open",
            entrypoint: entrypoint !== undefined && entrypoint !== null ? entrypoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see EarningsTrackerOpenViewIntroSplashEvent
 */
export var EarningsTrackerOpenViewIntroSplash = function (_a) {
    var entrypoint = _a.entrypoint;
    return ({
        name: "EarningsTracker Open ViewIntroSplash",
        parameters: {
            cdf_entity: "EarningsTracker",
            cdf_action: "Open",
            entrypoint: entrypoint !== undefined && entrypoint !== null ? entrypoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see EarningsTrackerOpenLoadAppletEvent
 */
export var EarningsTrackerOpenLoadApplet = function (_a) {
    var entrypoint = _a.entrypoint, trigger = _a.trigger, timeframe = _a.timeframe, timeframeMonth = _a.timeframeMonth, timeframeYear = _a.timeframeYear;
    return ({
        name: "EarningsTracker Open LoadApplet",
        parameters: {
            cdf_entity: "EarningsTracker",
            cdf_action: "Open",
            entrypoint: entrypoint !== undefined && entrypoint !== null ? entrypoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe: timeframe !== undefined && timeframe !== null ? timeframe.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_month: timeframeMonth !== undefined && timeframeMonth !== null ? timeframeMonth.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_year: timeframeYear !== undefined && timeframeYear !== null ? timeframeYear.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see EarningsTrackerOpenViewEarningsEvent
 */
export var EarningsTrackerOpenViewEarnings = function (_a) {
    var entrypoint = _a.entrypoint, timeframe = _a.timeframe, timeframeMonth = _a.timeframeMonth, timeframeYear = _a.timeframeYear;
    return ({
        name: "EarningsTracker Open ViewEarnings",
        parameters: {
            cdf_entity: "EarningsTracker",
            cdf_action: "Open",
            entrypoint: entrypoint !== undefined && entrypoint !== null ? entrypoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe: timeframe !== undefined && timeframe !== null ? timeframe.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_month: timeframeMonth !== undefined && timeframeMonth !== null ? timeframeMonth.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_year: timeframeYear !== undefined && timeframeYear !== null ? timeframeYear.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see EarningsTrackerOpenViewErrorEvent
 */
export var EarningsTrackerOpenViewError = function (_a) {
    var entrypoint = _a.entrypoint, timeframe = _a.timeframe, timeframeMonth = _a.timeframeMonth, timeframeYear = _a.timeframeYear;
    return ({
        name: "EarningsTracker Open ViewError",
        parameters: {
            cdf_entity: "EarningsTracker",
            cdf_action: "Open",
            entrypoint: entrypoint !== undefined && entrypoint !== null ? entrypoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe: timeframe !== undefined && timeframe !== null ? timeframe.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_month: timeframeMonth !== undefined && timeframeMonth !== null ? timeframeMonth.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_year: timeframeYear !== undefined && timeframeYear !== null ? timeframeYear.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see EarningsTrackerInteractChangeDisplayPillEvent
 */
export var EarningsTrackerInteractChangeDisplayPill = function (_a) {
    var timeframe = _a.timeframe, timeframeMonth = _a.timeframeMonth, timeframeYear = _a.timeframeYear;
    return ({
        name: "EarningsTracker Interact ChangeDisplayPill",
        parameters: {
            cdf_entity: "EarningsTracker",
            cdf_action: "Interact",
            timeframe: timeframe !== undefined && timeframe !== null ? timeframe.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_month: timeframeMonth !== undefined && timeframeMonth !== null ? timeframeMonth.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_year: timeframeYear !== undefined && timeframeYear !== null ? timeframeYear.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see EarningsTrackerInteractViewChartDetailsEvent
 */
export var EarningsTrackerInteractViewChartDetails = function (_a) {
    var timeframe = _a.timeframe, timeframeMonth = _a.timeframeMonth, timeframeYear = _a.timeframeYear;
    return ({
        name: "EarningsTracker Interact ViewChartDetails",
        parameters: {
            cdf_entity: "EarningsTracker",
            cdf_action: "Interact",
            timeframe: timeframe !== undefined && timeframe !== null ? timeframe.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_month: timeframeMonth !== undefined && timeframeMonth !== null ? timeframeMonth.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_year: timeframeYear !== undefined && timeframeYear !== null ? timeframeYear.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see EarningsTrackerInteractViewInfoSheetEvent
 */
export var EarningsTrackerInteractViewInfoSheet = function (_a) {
    var timeframe = _a.timeframe, timeframeMonth = _a.timeframeMonth, timeframeYear = _a.timeframeYear, infoContext = _a.infoContext;
    return ({
        name: "EarningsTracker Interact ViewInfoSheet",
        parameters: {
            cdf_entity: "EarningsTracker",
            cdf_action: "Interact",
            timeframe: timeframe !== undefined && timeframe !== null ? timeframe.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_month: timeframeMonth !== undefined && timeframeMonth !== null ? timeframeMonth.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_year: timeframeYear !== undefined && timeframeYear !== null ? timeframeYear.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            info_context: infoContext !== undefined && infoContext !== null ? infoContext.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see EarningsTrackerFilterOpenTimeframeSelectorEvent
 */
export var EarningsTrackerFilterOpenTimeframeSelector = function (_a) {
    var timeframe = _a.timeframe, timeframeMonth = _a.timeframeMonth, timeframeYear = _a.timeframeYear;
    return ({
        name: "EarningsTracker Filter OpenTimeframeSelector",
        parameters: {
            cdf_entity: "EarningsTracker",
            cdf_action: "Filter",
            timeframe: timeframe !== undefined && timeframe !== null ? timeframe.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_month: timeframeMonth !== undefined && timeframeMonth !== null ? timeframeMonth.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_year: timeframeYear !== undefined && timeframeYear !== null ? timeframeYear.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see EarningsTrackerFilterUpdateTimeframeEvent
 */
export var EarningsTrackerFilterUpdateTimeframe = function (_a) {
    var timeframe = _a.timeframe, timeframeMonth = _a.timeframeMonth, timeframeYear = _a.timeframeYear;
    return ({
        name: "EarningsTracker Filter UpdateTimeframe",
        parameters: {
            cdf_entity: "EarningsTracker",
            cdf_action: "Filter",
            timeframe: timeframe !== undefined && timeframe !== null ? timeframe.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_month: timeframeMonth !== undefined && timeframeMonth !== null ? timeframeMonth.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeframe_year: timeframeYear !== undefined && timeframeYear !== null ? timeframeYear.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
